import Dropdown from "@stimulus-components/dropdown"

export default class extends Dropdown {
    connect() {
        super.connect()
    }

    toggle() {
        super.toggle()
    }

    hide(event) {
        super.hide(event)
    }
}